import {Locale} from '../locale';
import {nativeLanguageByLocale} from '../nativeLanguageByLocale';
import {
  ASSETS_URL_DESKTOP_DEVELOPMENT,
  ASSETS_URL_MOBILE_DEVELOPMENT,
  IRIS_URL_DEVELOPMENT,
  KLARNA_SDK_URL_STAGING,
  getDesktopHelpCenterEndpointByLocale,
} from './constants';
import {HttpUrl, UrlMapping} from './types';

const desktopHelpCenterEndpointByLocale =
  getDesktopHelpCenterEndpointByLocale(IRIS_URL_DEVELOPMENT);

const sendSmsEndpoint = `${IRIS_URL_DEVELOPMENT}/sms` as HttpUrl;

export const development: UrlMapping<'development'> = {
  [Locale.en_ZZ]: {
    environment: 'development',
    locale: Locale.en_ZZ,
    urlSets: [
      {
        hostname: 'www.aboutyou.com.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'http://es.aboutyou.com.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.com.local',
        publicDesktopHostname: 'www.aboutyou.com.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'http://m-es.aboutyou.com.local:8888',
            alternateDomainUrl: 'http://m-es.aboutyou.com.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.es_ZZ]: {
    environment: 'development',
    locale: Locale.es_ZZ,
    urlSets: [
      {
        hostname: 'es.aboutyou.com.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-es.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'http://www.aboutyou.com.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-es.aboutyou.com.local',
        publicDesktopHostname: 'es.aboutyou.com.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-es.aboutyou-staging.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'http://m.aboutyou.com.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.com.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.de_DE]: {
    environment: 'development',
    locale: Locale.de_DE,
    urlSets: [
      {
        hostname: 'www.aboutyou.de.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'http://en.aboutyou.de.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
      {
        hostname: 'm.aboutyou.de.local',
        publicDesktopHostname: 'www.aboutyou.de.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'http://m-en.aboutyou.de.local:8888',
            alternateDomainUrl: 'http://m-en.aboutyou.de.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
    ],
  },
  [Locale.en_DE]: {
    environment: 'development',
    locale: Locale.en_DE,
    urlSets: [
      {
        hostname: 'en.aboutyou.de.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'http://www.aboutyou.de.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
      {
        hostname: 'm-en.aboutyou.de.local',
        publicDesktopHostname: 'en.aboutyou.de.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'http://m.aboutyou.de.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.de.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
    ],
  },
  [Locale.de_AT]: {
    environment: 'development',
    locale: Locale.de_AT,
    urlSets: [
      {
        hostname: 'www.aboutyou.at.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'http://en.aboutyou.at.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm.aboutyou.at.local',
        publicDesktopHostname: 'www.aboutyou.at.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'http://m-en.aboutyou.at.local:7777',
            alternateDomainUrl: 'http://m-en.aboutyou.at.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
  },
  [Locale.en_AT]: {
    environment: 'development',
    locale: Locale.en_AT,
    urlSets: [
      {
        hostname: 'en.aboutyou.at.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'http://www.aboutyou.at.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm-en.aboutyou.at.local',
        publicDesktopHostname: 'en.aboutyou.at.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'http://m.aboutyou.at.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.at.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
  },
  [Locale.de_CH]: {
    environment: 'development',
    locale: Locale.de_CH,
    urlSets: [
      {
        hostname: 'www.aboutyou.ch.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'http://fr.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://it.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://en.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm.aboutyou.ch.local',
        publicDesktopHostname: 'www.aboutyou.ch.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'http://m-fr.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-fr.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://m-it.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-it.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://m-en.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-en.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
  },
  [Locale.fr_CH]: {
    environment: 'development',
    locale: Locale.fr_CH,
    urlSets: [
      {
        hostname: 'fr.aboutyou.ch.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-fr.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://www.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://it.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://en.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
      {
        hostname: 'm-fr.aboutyou.ch.local',
        publicDesktopHostname: 'fr.aboutyou.ch.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-fr.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://m.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://m-it.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-it.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://m-en.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-en.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
    ],
  },
  [Locale.it_CH]: {
    environment: 'development',
    locale: Locale.it_CH,
    urlSets: [
      {
        hostname: 'it.aboutyou.ch.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-it.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://www.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'http://fr.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://en.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
      {
        hostname: 'm-it.aboutyou.ch.local',
        publicDesktopHostname: 'it.aboutyou.ch.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-it.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://m.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'http://m-fr.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-fr.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'http://m-en.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-en.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
    ],
  },
  [Locale.en_CH]: {
    environment: 'development',
    locale: Locale.en_CH,
    urlSets: [
      {
        hostname: 'en.aboutyou.ch.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://www.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'http://fr.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://it.aboutyou.ch.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm-en.aboutyou.ch.local',
        publicDesktopHostname: 'en.aboutyou.ch.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'http://m.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'http://m-fr.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-fr.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'http://m-it.aboutyou.ch.local:8888',
            alternateDomainUrl: 'http://m-it.aboutyou.ch.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
  },
  [Locale.nl_NL]: {
    environment: 'development',
    locale: Locale.nl_NL,
    urlSets: [
      {
        hostname: 'www.aboutyou.nl.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'http://en.aboutyou.nl.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
      {
        hostname: 'm.aboutyou.nl.local',
        publicDesktopHostname: 'www.aboutyou.nl.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'http://m-en.aboutyou.nl.local:8888',
            alternateDomainUrl: 'http://m-en.aboutyou.nl.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
    ],
  },
  [Locale.en_NL]: {
    environment: 'development',
    locale: Locale.en_NL,
    urlSets: [
      {
        hostname: 'en.aboutyou.nl.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-en.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'http://www.aboutyou.nl.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
      {
        hostname: 'm-en.aboutyou.nl.local',
        publicDesktopHostname: 'en.aboutyou.nl.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-en.aboutyou-staging.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'http://m.aboutyou.nl.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.nl.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
    ],
  },
  [Locale.nl_BE]: {
    environment: 'development',
    locale: Locale.nl_BE,
    urlSets: [
      {
        hostname: 'www.aboutyou.be.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'http://fr.aboutyou.be.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
      {
        hostname: 'm.aboutyou.be.local',
        publicDesktopHostname: 'www.aboutyou.be.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'http://m-fr.aboutyou.be.local:8888',
            alternateDomainUrl: 'http://m-fr.aboutyou.be.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
    ],
  },
  [Locale.fr_BE]: {
    environment: 'development',
    locale: Locale.fr_BE,
    urlSets: [
      {
        hostname: 'fr.aboutyou.be.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-fr.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'http://www.aboutyou.be.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
      {
        hostname: 'm-fr.aboutyou.be.local',
        publicDesktopHostname: 'fr.aboutyou.be.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-fr.aboutyou-staging.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'http://m.aboutyou.be.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.be.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
    ],
  },
  [Locale.pl_PL]: {
    environment: 'development',
    locale: Locale.pl_PL,
    urlSets: [
      {
        hostname: 'www.aboutyou.pl.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
      {
        hostname: 'm.aboutyou.pl.local',
        publicDesktopHostname: 'www.aboutyou.pl.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
    ],
  },
  [Locale.cs_CZ]: {
    environment: 'development',
    locale: Locale.cs_CZ,
    urlSets: [
      {
        hostname: 'www.aboutyou.cz.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
      {
        hostname: 'm.aboutyou.cz.local',
        publicDesktopHostname: 'www.aboutyou.cz.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
    ],
  },
  [Locale.ro_RO]: {
    environment: 'development',
    locale: Locale.ro_RO,
    urlSets: [
      {
        hostname: 'www.aboutyou.ro.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
      {
        hostname: 'm.aboutyou.ro.local',
        publicDesktopHostname: 'www.aboutyou.ro.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
    ],
  },
  [Locale.hu_HU]: {
    environment: 'development',
    locale: Locale.hu_HU,
    urlSets: [
      {
        hostname: 'www.aboutyou.hu.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
      {
        hostname: 'm.aboutyou.hu.local',
        publicDesktopHostname: 'www.aboutyou.hu.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
    ],
  },
  [Locale.sk_SK]: {
    environment: 'development',
    locale: Locale.sk_SK,
    urlSets: [
      {
        hostname: 'www.aboutyou.sk.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
      {
        hostname: 'm.aboutyou.sk.local',
        publicDesktopHostname: 'www.aboutyou.sk.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
    ],
  },
  [Locale.sl_SI]: {
    environment: 'development',
    locale: Locale.sl_SI,
    urlSets: [
      {
        hostname: 'www.aboutyou.si.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
      {
        hostname: 'm.aboutyou.si.local',
        publicDesktopHostname: 'www.aboutyou.si.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
    ],
  },
  [Locale.lv_LV]: {
    environment: 'development',
    locale: Locale.lv_LV,
    urlSets: [
      {
        hostname: 'www.aboutyou.lv.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'http://ru.aboutyou.lv.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm.aboutyou.lv.local',
        publicDesktopHostname: 'www.aboutyou.lv.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'http://m-ru.aboutyou.lv.local:8888',
            alternateDomainUrl: 'http://m-ru.aboutyou.lv.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
  },
  [Locale.ru_LV]: {
    environment: 'development',
    locale: Locale.ru_LV,
    urlSets: [
      {
        hostname: 'ru.aboutyou.lv.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-ru.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'http://www.aboutyou.lv.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm-ru.aboutyou.lv.local',
        publicDesktopHostname: 'ru.aboutyou.lv.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-ru.aboutyou-staging.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'http://m.aboutyou.lv.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.lv.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
  },
  [Locale.lt_LT]: {
    environment: 'development',
    locale: Locale.lt_LT,
    urlSets: [
      {
        hostname: 'www.aboutyou.lt.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
      {
        hostname: 'm.aboutyou.lt.local',
        publicDesktopHostname: 'www.aboutyou.lt.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
    ],
  },
  [Locale.et_EE]: {
    environment: 'development',
    locale: Locale.et_EE,
    urlSets: [
      {
        hostname: 'www.aboutyou.ee.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'http://ru.aboutyou.ee.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm.aboutyou.ee.local',
        publicDesktopHostname: 'www.aboutyou.ee.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'http://m-ru.aboutyou.ee.local:8888',
            alternateDomainUrl: 'http://m-ru.aboutyou.ee.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
  },
  [Locale.ru_EE]: {
    environment: 'development',
    locale: Locale.ru_EE,
    urlSets: [
      {
        hostname: 'ru.aboutyou.ee.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout-ru.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'http://www.aboutyou.ee.local:7777',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm-ru.aboutyou.ee.local',
        publicDesktopHostname: 'ru.aboutyou.ee.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m-ru.aboutyou-staging.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'http://m.aboutyou.ee.local:8888',
            alternateDomainUrl: 'http://m.aboutyou.ee.local:8888',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
  },
  [Locale.hr_HR]: {
    environment: 'development',
    locale: Locale.hr_HR,
    urlSets: [
      {
        hostname: 'www.aboutyou.hr.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
      {
        hostname: 'm.aboutyou.hr.local',
        publicDesktopHostname: 'www.aboutyou.hr.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
    ],
  },
  [Locale.bg_BG]: {
    environment: 'development',
    locale: Locale.bg_BG,
    urlSets: [
      {
        hostname: 'www.aboutyou.bg.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.bg.local',
        publicDesktopHostname: 'www.aboutyou.bg.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.fr_FR]: {
    environment: 'development',
    locale: Locale.fr_FR,
    urlSets: [
      {
        hostname: 'www.aboutyou.fr.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
      {
        hostname: 'm.aboutyou.fr.local',
        publicDesktopHostname: 'www.aboutyou.fr.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
    ],
  },
  [Locale.da_DK]: {
    environment: 'development',
    locale: Locale.da_DK,
    urlSets: [
      {
        hostname: 'www.aboutyou.dk.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
      {
        hostname: 'm.aboutyou.dk.local',
        publicDesktopHostname: 'www.aboutyou.dk.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
    ],
  },
  [Locale.sv_SE]: {
    environment: 'development',
    locale: Locale.sv_SE,
    urlSets: [
      {
        hostname: 'www.aboutyou.se.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
      {
        hostname: 'm.aboutyou.se.local',
        publicDesktopHostname: 'www.aboutyou.se.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
    ],
  },
  [Locale.fi_FI]: {
    environment: 'development',
    locale: Locale.fi_FI,
    urlSets: [
      {
        hostname: 'www.aboutyou.fi.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
      {
        hostname: 'm.aboutyou.fi.local',
        publicDesktopHostname: 'www.aboutyou.fi.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
    ],
  },
  [Locale.es_ES]: {
    environment: 'development',
    locale: Locale.es_ES,
    urlSets: [
      {
        hostname: 'www.aboutyou.es.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
      {
        hostname: 'm.aboutyou.es.local',
        publicDesktopHostname: 'www.aboutyou.es.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
    ],
  },
  [Locale.it_IT]: {
    environment: 'development',
    locale: Locale.it_IT,
    urlSets: [
      {
        hostname: 'www.aboutyou.it.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
      {
        hostname: 'm.aboutyou.it.local',
        publicDesktopHostname: 'www.aboutyou.it.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
    ],
  },
  [Locale.pt_PT]: {
    environment: 'development',
    locale: Locale.pt_PT,
    urlSets: [
      {
        hostname: 'www.aboutyou.pt.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
      {
        hostname: 'm.aboutyou.pt.local',
        publicDesktopHostname: 'www.aboutyou.pt.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
    ],
  },
  [Locale.el_GR]: {
    environment: 'development',
    locale: Locale.el_GR,
    urlSets: [
      {
        hostname: 'www.aboutyou.gr.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.gr.local',
        publicDesktopHostname: 'www.aboutyou.gr.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.el_CY]: {
    environment: 'development',
    locale: Locale.el_CY,
    urlSets: [
      {
        hostname: 'www.aboutyou.com.cy.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.com.cy.local',
        publicDesktopHostname: 'www.aboutyou.com.cy.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout-m.aboutyou-staging.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.fr_LU]: {
    environment: 'development',
    locale: Locale.fr_LU,
    urlSets: [
      {
        hostname: 'www.aboutyou.lu.local',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
      {
        hostname: 'm.aboutyou.lu.local',
        publicDesktopHostname: 'www.aboutyou.lu.local',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_DEVELOPMENT,
        legacyCheckout: 'https://checkout.aboutyou-staging.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        sms_POST: sendSmsEndpoint,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou-staging.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
    ],
  },
};
